import { Circle, Icon } from '@chakra-ui/react'
import { HiCheck } from 'react-icons/hi'

export const StepCircle = (props) => {
    const { isCompleted, isActive, ...rest } = props
    return (
        <Circle
            size="20"
            bg={isCompleted ? 'accent' : 'inherit'}
            borderWidth={isCompleted ? '2px' : '2px'}
            borderColor={isActive ? 'accent' : 'inherit'}
            {...rest}
        >
            {isCompleted ? (
                <Icon as={HiCheck} color="fg.inverted" boxSize="10"
                />
            ) : (
                <Circle bg={isActive ? 'accent' : 'border'} size="10" />
            )}
        </Circle>
    )
}